import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { PROFILE } from "@/data";

const LINKS = [
  { label: "Story", href: "#story" },
  { label: "Verified", href: "#verified" },
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="nav-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "bg-[#0A1730]/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="font-display font-extrabold tracking-tight text-lg text-[#F3EFE6]">
          SUMON<span className="text-[#D9A441]">.</span>
        </a>
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-semibold text-[#9DAEC4] hover:text-[#D9A441] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <span className="hidden sm:flex items-center gap-2 text-xs font-mono text-[#9DAEC4]" data-testid="nav-status">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse-dot" />
            Available for projects
          </span>
          <a
            href={PROFILE.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-btn"
            className="flex items-center gap-2 bg-[#D9A441] hover:bg-[#E5B85C] text-[#0A1730] text-sm font-bold px-4 py-2 rounded-full transition-colors duration-300"
          >
            <MessageCircle size={15} />
            <span className="hidden sm:inline">Hire Sumon</span>
          </a>
        </div>
      </div>
    </header>
  );
}
